import { type MCPServerInfo } from '../../types';

const FullstoryLexiconServer: MCPServerInfo = {
  serverId: 'FULLSTORY_LEXICON',
  name: 'FullStory Lexicon',
  slug: 'fullstory-lexicon',
  description:
    'Enterprise-grade MCP server for FullStory (Lexicon). Provides FullStory API tools plus system diagnostics over Streamable HTTP.',
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/fullstorydev/fs-lexicon',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'lexicon-mcp'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['fsProdApiKey', 'fsOrgId'],
    properties: {
      fsProdApiKey: {
        type: 'string',
        description: 'FullStory API key (Lexicon env: FS_PROD_API_KEY)',
        sensitive: true
      },
      fsOrgId: {
        type: 'string',
        description: 'FullStory org ID (Lexicon env: FS_ORG_ID)',
        sensitive: false
      },
      fullstoryDatacenter: {
        type: 'string',
        description: 'FullStory datacenter (Lexicon env: FS_DC)',
        sensitive: false,
        default: 'NA1'
      },
      safeMode: {
        type: 'boolean',
        description: 'If true, restricts to read-only tools (env: SAFE_MODE)',
        sensitive: false,
        default: 'false'
      },
      mcpAuthEnabled: {
        type: 'boolean',
        description:
          'Enable OAuth 2.1 auth (disabled by default) (env: MCP_AUTH_ENABLED)',
        sensitive: false,
        default: 'false'
      },
      mcpAuthServerUrl: {
        type: 'string',
        description:
          'OAuth authorization server URL (env: MCP_AUTH_SERVER_URL)',
        sensitive: false
      },
      mcpServerCanonicalUri: {
        type: 'string',
        description:
          "This MCP server's canonical URI (env: MCP_SERVER_CANONICAL_URI)",
        sensitive: false
      },
      mcpAuthClientId: {
        type: 'string',
        description: 'OAuth client ID (env: MCP_AUTH_CLIENT_ID)',
        sensitive: false
      },
      rateLimitEnabled: {
        type: 'boolean',
        description:
          'Enable MCP + tool-level rate limiting (env: RATE_LIMIT_ENABLED)',
        sensitive: false,
        default: 'true'
      },
      rateLimitUseRedis: {
        type: 'boolean',
        description:
          'Use Redis for distributed rate limiting (env: RATE_LIMIT_USE_REDIS)',
        sensitive: false,
        default: 'false'
      },
      rateLimitRedisUrl: {
        type: 'string',
        description: 'Redis URL for rate limiting (env: RATE_LIMIT_REDIS_URL)',
        sensitive: true
      }
    }
  }
};

export default FullstoryLexiconServer;
